import ExpandIcon from "@mui/icons-material/ExpandMoreRounded";
import { Accordion, AccordionDetails, AccordionSummary, Divider, Stack, TextField, Typography } from "@mui/material";
import type { Ref } from "react";
import WorkflowAgentLabel from "./WorkflowAgentLabel";
import WorkflowSystemPrompt from "./WorkflowSystemPrompt";

export interface ActivityPromptState {
  activityId: string;
  activityName: string;
  taskSystemPrompt?: string | null;
  validationSystemPrompt?: string | null;
  taskPrompt: string;
  validationPrompt: string;
}

interface Props {
  activity: ActivityPromptState;
  showSystemPrompts: boolean;
  isEntriliaUser: boolean;
  onPromptChange: (activityId: string, field: "taskPrompt" | "validationPrompt", value: string) => void;
  expanded: boolean;
  onExpandedChange: (newExpanded: boolean) => void;
  taskPromptInputRef?: Ref<HTMLTextAreaElement>;
}

const WorkflowTemplateInstructionsActivityCard = ({
  activity,
  showSystemPrompts,
  isEntriliaUser,
  onPromptChange,
  expanded,
  onExpandedChange,
  taskPromptInputRef,
}: Props) => (
  <Accordion
    variant="outlined"
    disableGutters
    expanded={expanded}
    onChange={(_, newExpanded) => onExpandedChange(newExpanded)}
  >
    <AccordionSummary expandIcon={<ExpandIcon />} sx={(t) => ({ bgcolor: t.palette.background.grey })}>
      <Typography variant="subtitle1">{activity.activityName}</Typography>
    </AccordionSummary>
    <AccordionDetails sx={(t) => ({ px: 2, py: 1.5, borderTop: `1px solid ${t.palette.divider}` })}>
      <Stack spacing={2}>
        <Stack spacing={2}>
          <WorkflowAgentLabel agentType="task" />
          <Stack spacing={2} sx={{ pl: 4 }}>
            <TextField
              fullWidth
              multiline
              rows={12}
              inputRef={taskPromptInputRef}
              value={activity.taskPrompt}
              onChange={(e) => onPromptChange(activity.activityId, "taskPrompt", e.target.value)}
              disabled={!activity.taskSystemPrompt}
            />
            {isEntriliaUser && showSystemPrompts && activity.taskSystemPrompt?.trim() && (
              <WorkflowSystemPrompt value={activity.taskSystemPrompt} />
            )}
          </Stack>
        </Stack>

        <Divider flexItem sx={{ borderStyle: "dashed" }} />

        <Stack spacing={2}>
          <WorkflowAgentLabel agentType="validation" />
          <Stack spacing={2} sx={{ pl: 4 }}>
            <TextField
              fullWidth
              multiline
              rows={12}
              value={activity.validationPrompt}
              onChange={(e) => onPromptChange(activity.activityId, "validationPrompt", e.target.value)}
              disabled={!activity.validationSystemPrompt}
            />
            {isEntriliaUser && showSystemPrompts && activity.validationSystemPrompt?.trim() && (
              <WorkflowSystemPrompt value={activity.validationSystemPrompt} />
            )}
          </Stack>
        </Stack>
      </Stack>
    </AccordionDetails>
  </Accordion>
);

export default WorkflowTemplateInstructionsActivityCard;
